import { usePersonsByIds } from '@app/modules/persons/hooks/usePersonsByIds';
import { Fragment } from '@app/modules/fragments/types';
import { useWebAppGetFragmentDetailTranscriptionSuspense } from '@mi-front/api-v2';
import { useMemo } from 'react';
import { mapTranscriptionDtoToBlocks } from '../lib/transcription-mapper';

/**
 * Fetches fragment transcription with Suspense, batch-warms Person cache for
 * any diarization person_ids, and maps to v2 transcript blocks.
 */
export function useFragmentTranscription(fragment: Fragment) {
  const { data } = useWebAppGetFragmentDetailTranscriptionSuspense(fragment.id, {});

  const personIds = useMemo(() => {
    if (!data?.diarization) {
      return [];
    }
    return (data.diarization as { person_id?: string }[])
      .map((d) => d.person_id)
      .filter((id): id is string => !!id);
  }, [data]);

  usePersonsByIds(personIds);

  const blocks = useMemo(() => {
    if (!data) {
      return [];
    }

    return mapTranscriptionDtoToBlocks(data);
  }, [data]);

  return {
    blocks,
  };
}
